// extracted by mini-css-extract-plugin
export default {"sectionWrapper":"hq-z","outfitFeedbackSection":"iq-z"};